import * as React from 'react';

export const LineBreak: React.FC<{}> = ({}) => {
  return <div style={{ borderBottom: '1px solid gold', marginTop: 5, marginBottom: 5 }}></div>;
};
